skrilla.controller('pickemsNotifyModalCtrl', function ($scope, searchService, cacheService, srefService, modalService, queryService, paginationService, sportService) {

  $scope.contest =cacheService.getObject("contest");
  $scope.newMarkets= true

  $scope.notify = function () {
      searchService.post("pickems/contests/" + $scope.contest.id + "/notify", {
          newMarkets: $scope.newMarkets,
          message: $scope.message
      },"Entrants notified!")
  };


  $scope.close = function () {
    modalService.dismissAll();
  }

});
